import { useEffect, useRef } from 'react';

import { createRoutineLaunchLock, type RoutineLaunchLock } from './routineLaunchGuard';

/**
 * Mutation callbacks never fire after unmount, so without the unmount release
 * an abandoned launch holds the routine's lock for the rest of the session.
 */
export function useRoutineLaunchLock(): RoutineLaunchLock {
  const lockRef = useRef(createRoutineLaunchLock());
  useEffect(() => {
    const lock = lockRef.current;
    return () => lock.releaseAll();
  }, []);
  return lockRef.current;
}
